import {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {service} from '../redux/service'

interface Props {
  id: string
  handleClose: () => void
}

const Field = ({label, value}: {label: string; value?: string | number | null}) => (
  <div className='col-md-4 mb-3'>
    <div className='text-muted small'>{label}</div>
    <div className='fw-semibold'>{value ?? '-'}</div>
  </div>
)

const ViewLoanEligibilityDetails = ({id, handleClose}: Props) => {
  const [record, setRecord] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    service
      .getLoanEligibilityReportDetail(id)
      .then((res) => setRecord(res.data?.data))
      .catch(() => toast.error('Failed to load loan eligibility request details.'))
      .finally(() => setLoading(false))
  }, [id])

  return (
    <div className='modal show d-block' style={{background: 'rgba(0,0,0,0.5)'}}>
      <div className='modal-dialog modal-xl modal-dialog-scrollable'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>
              Loan Eligibility Request — {record?.eligibility_code || id}
            </h5>
            <button className='btn-close' onClick={handleClose} />
          </div>
          <div className='modal-body'>
            {loading ? (
              <div className='text-center py-5'>
                <div className='spinner-border text-primary' />
              </div>
            ) : !record ? (
              <div className='alert alert-danger'>Request not found.</div>
            ) : (
              <div className='row'>
                <Field label='Eligibility Code' value={record.eligibility_code} />
                <Field label='Salutation' value={record.salutation} />
                <Field
                  label='Full Name'
                  value={[record.first_name, record.middle_name, record.last_name]
                    .filter(Boolean)
                    .join(' ')}
                />
                <Field label='Email Address' value={record.email_address} />
                <Field label='Mobile Number' value={record.mobile_number} />
                <Field label='Nationality' value={record.nationality} />
                <Field label='Date of Birth (AD)' value={record.date_of_birth_ad} />
                <Field label='Date of Birth (BS)' value={record.date_of_birth_bs} />
                <Field label='Preferred Branch' value={record.branch?.title} />
                <Field label='Monthly Salary' value={record.monthly_salary} />
                <Field label='Loan Type' value={record.loan_type} />
                <Field label='Other EMIs' value={record.other_emis} />
                <Field label='Interest Rate' value={record.interest_rate} />
                <Field label='Loan Amount' value={record.loan_amount} />
                <Field label='Loan Tenure' value={record.loan_tenure} />
                <Field label='Max Eligible EMI' value={record.max_eligible_emi} />
                <Field label='Eligible Amount' value={record.eligible_amount} />
                <Field label='Eligibility Status' value={record.eligibility_status} />
                <Field label='Request Status' value={record.request_status} />
                <Field label='Submitted At' value={record.submission_date_time} />
              </div>
            )}
          </div>
          <div className='modal-footer'>
            <button className='btn btn-secondary btn-sm' onClick={handleClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewLoanEligibilityDetails
